// components/wizard/Title.jsx
import React, { useState } from 'react';
import { Loader } from 'lucide-react';

const Title = ({ formData, updateFormData, onNext, onBack, saving }) => {
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (saving) return;
    if (!formData.title.trim()) {
      setError('Title is required');
      return;
    }
    onNext();
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6">Manuscript Title</h3>
      
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Title <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.title}
          onChange={(e) => {
            updateFormData({ title: e.target.value });
            setError('');
          }}
          className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-[--asfi-blue] ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="Enter your manuscript title"
        />
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      </div>

      <p className="text-sm text-red-500 mb-6">* Indicates Mandatory Fields</p>

      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-8 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
        >
          Back
        </button>
        
        <button
          onClick={handleSubmit}
          disabled={saving}
          className="px-8 py-3 bg-[--asfi-blue] text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
        >
          {saving ? (
            <>
              <Loader className="w-4 h-4 animate-spin inline mr-2" />
              Saving...
            </>
          ) : (
            'Save & Continue'
          )}
        </button>
      </div>
    </div>
  );
};

export default Title;
